import React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { Loader2 } from 'lucide-react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ChatInterface from './ChatInterface';
import ProfileSelection from './ProfileSelection';
import './App.css';

function AppRoutes() {
  const { initialized, keycloak } = useKeycloak();

  if (!initialized) {
    return (
      <div className="app">
        <div className="loading-screen">
          <Loader2 className="spin" size={48} />
          <p>Initializing authentication...</p>
        </div>
      </div>
    );
  }

  if (!keycloak.authenticated) {
    return (
      <div className="app">
        <div className="loading-screen">
          <Loader2 className="spin" size={48} />
          <p>Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/select" replace />} />
      <Route path="/select" element={<ProfileSelection />} />
      <Route path="/chat" element={<ChatInterface />} />
      <Route path="*" element={<Navigate to="/select" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
